module.exports = __webpack_public_path__ + "img/not_found_data1.3b933a30.png";